/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PutApiEmployeesIdMutationRequest,
  PutApiEmployeesIdMutationResponse,
  PutApiEmployeesIdPathParams,
} from '../models/PutApiEmployeesId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  putApiEmployeesIdMutationResponseSchema,
  putApiEmployeesIdMutationRequestSchema,
} from '../zod/putApiEmployeesIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const putApiEmployeesIdMutationKey = () =>
  [{ url: '/api/employees/:id' }] as const;

export type PutApiEmployeesIdMutationKey = ReturnType<
  typeof putApiEmployeesIdMutationKey
>;

/**
 * {@link /api/employees/:id}
 */
export async function putApiEmployeesId(
  id: PutApiEmployeesIdPathParams['id'],
  data: PutApiEmployeesIdMutationRequest,
  config: Partial<RequestConfig<PutApiEmployeesIdMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = putApiEmployeesIdMutationRequestSchema.parse(data);
  const res = await request<
    PutApiEmployeesIdMutationResponse,
    ResponseErrorConfig<Error>,
    PutApiEmployeesIdMutationRequest
  >({
    method: 'PUT',
    url: `/api/employees/${id}`,
    data: requestData,
    ...requestConfig,
  });
  return putApiEmployeesIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/employees/:id}
 */
export function usePutApiEmployeesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiEmployeesIdMutationResponse,
      ResponseErrorConfig<Error>,
      {
        id: PutApiEmployeesIdPathParams['id'];
        data: PutApiEmployeesIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiEmployeesIdMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiEmployeesIdMutationKey();

  return useMutation<
    PutApiEmployeesIdMutationResponse,
    ResponseErrorConfig<Error>,
    {
      id: PutApiEmployeesIdPathParams['id'];
      data: PutApiEmployeesIdMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return putApiEmployeesId(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
